import { FlexColumn } from '@gorila-shared-ui/components';
import { Filter } from 'baseui/table';
import { memo } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import ConfigurationTriggerTypeSelect from '../../shared/selects/ConfigurationTriggerTypeSelect';
import MaintenanceTypeSelect from '../../shared/selects/MaintenanceTypeSelect';
import useMaintenanceConfigurations from '../hooks/useMaintenanceConfigurations';

export function MaintenanceConfigurationsFilters() {
  const { theme, css, overrides } = useStyles();
  const { filters, hasActiveFilters, resetFilters, onChangeFilter } = useMaintenanceConfigurations();

  return (
    <Filter
      active={hasActiveFilters}
      overrides={overrides.filtersOverrides(resetFilters)}
    >
      <FlexColumn
        classNames={css({
          paddingTop: theme.sizing.scale500,
          paddingBottom: theme.sizing.scale500,
        })}
        gap={theme.sizing.scale200}
      >
        <ConfigurationTriggerTypeSelect
          selectedId={filters.triggerType}
          onChangeId={(triggerType) => onChangeFilter('triggerType', triggerType)}
          showEmptyOption
          inline
          isFilter
        />
        <MaintenanceTypeSelect
          selectedMaintenanceTypeId={filters.maintenanceTypeId}
          onChangeMaintenanceTypeId={(maintenanceTypeId) => onChangeFilter('maintenanceTypeId', maintenanceTypeId)}
          showEmptyOption
          inline
          isFilter
        />
      </FlexColumn>
    </Filter>
  );
}

export default memo(MaintenanceConfigurationsFilters);
